"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _analyticsInterface = require("@telus/analytics-interface");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _unset2 = _interopRequireDefault(require("lodash/unset"));
var _index = require("../../utils/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var persistWebPageDetails = function persistWebPageDetails(event) {
  var webPageDetails = (0, _cloneDeep2["default"])((0, _get2["default"])(event, 'xdm.web.webPageDetails'));
  (0, _unset2["default"])(webPageDetails, 'pageViews');
  (0, _unset2["default"])(webPageDetails, '_telus.customPageViews');
  (0, _analyticsInterface.pageDetails)().set((0, _index.removeEmptyKeys)(webPageDetails));
  return event;
};
var _default = exports["default"] = persistWebPageDetails;